const SEARCH_PATH = '/travel/#results';
const APP_SEARCH_PATH = 'app://results/';

export function backToSearch(searchParams = {}) {
  if (!searchParams || !Array.isArray(searchParams?.searchSegments)) return '/';
  return `${SEARCH_PATH}/${buildSearchQuery(searchParams)}`;
}

export function backToSearchInApp(
  searchParams,
  brand = 'ED',
  executeSearch = true
) {
  const basePath = `${brand.toLowerCase()}-${APP_SEARCH_PATH}`;

  if (!searchParams || !Array.isArray(searchParams?.searchSegments))
    return basePath;

  return `${basePath}result;${buildSearchQuery(
    searchParams
  )};executeSearch=${executeSearch}`;
}

function buildSearchQuery(searchParams) {
  const search = {
    type: searchParams.type === 'roundTrip' ? 'R' : 'O',
    from: searchParams.searchSegments[0].departure.iata,
    to: searchParams.searchSegments[0].destination.iata,
    dep: searchParams.searchSegments[0].dateStr,
    ret:
      searchParams.searchSegments.length > 1
        ? searchParams.searchSegments[1].dateStr
        : '',
    adults: searchParams.numAdults,
    buyPath: searchParams.buyPath,
    internalSearch: searchParams.internalSearch,
  };

  const returnSegment = search.type === 'R' ? `ret=${search.ret};` : '';

  return `type=${search.type};from=${search.from};to=${search.to};dep=${search.dep};${returnSegment}adults=${search.adults};buyPath=${search.buyPath};internalSearch=${search.internalSearch}`;
}
